<template>
  <div>
    <v-list-item-avatar :size="avatarSize">
      <img :src="imagenUrl" alt="Image" />
    </v-list-item-avatar>
  </div>
</template>

<script>
import { resolveImageUrl } from '@/services/s3Upload.service'

export default {
  name: 'ThumborImage',
  props: {
    imageUrl: {
      type: String,
      default: null,
    },
    avatarSize: {
      type: Number,
      default: 30,
    },
    tipoImagen: {
      type: String,
      default: 'imagen',
    },
  },
  computed: {
    imagenUrl() {
      if (this.imageUrl) {
        return resolveImageUrl(this.imageUrl)
      }
      if (this.tipoImagen === 'foto') {
        return '/images/photo-placeholder.png'
      }
      return '/images/image-placeholder.png'
    },
  },
}
</script>
